import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import Nav from "@/components/Nav";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // Already logged in? Skip login.
  useEffect(() => {
    if (!user) return;
    const dest = user.role === "admin" ? "/admin"
               : user.role === "designer" ? "/designer"
               : user.role === "vendor" ? "/vendor"
               : "/dashboard";
    nav(dest, { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      const dest = u.role === "admin" ? "/admin"
                 : u.role === "designer" ? "/designer"
                 : u.role === "vendor" ? "/vendor"
                 : "/dashboard";
      nav(dest);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[var(--pf-bg)]">
      <Nav />
      <div className="max-w-md mx-auto px-6 py-16">
        <div className="pf-label mb-4">Access · Client + Admin</div>
        <h1 className="text-5xl font-black tracking-tighter mb-10">Log in.</h1>
        <form onSubmit={submit} className="space-y-8" data-testid="login-form">
          <div>
            <label className="pf-label block mb-2">Email</label>
            <input data-testid="login-email" type="email" required className="pf-input" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="you@company.com" />
          </div>
          <div>
            <label className="pf-label block mb-2">Password</label>
            <input data-testid="login-password" type="password" required minLength={6} className="pf-input" value={password} onChange={(e)=>setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit" className="pf-btn-primary w-full justify-center">
            {loading ? "Signing in…" : "Sign in →"}
          </button>
        </form>
        <div className="mt-10 text-sm text-[var(--pf-text-2)]">
          No account? <Link to="/signup" data-testid="login-signup-link" className="text-[var(--pf-text)] underline underline-offset-4 font-medium">Create one</Link>
        </div>
      </div>
    </div>
  );
}
